import React from 'react';
import { withRouter } from 'react-router-dom';
import {
    Grid,
    Typography,
    makeStyles,
    Divider,
    useMediaQuery
} from '@material-ui/core';

import { DriveEta as CarroIcon } from '@material-ui/icons';
import { MenuEnum } from '../../enums';

import {
    Header,
    Body,
    CardServico,
    CardServicoInexistente
} from '../../presentations';
import { StepperCard } from '../../presentations/web';
import { SwiperCard } from '../../presentations/mobile';

const styles = makeStyles(theme => ({
    titulo: {
        margin: '10px 0px 0px 10px',
        color: theme.palette.primary.main
    },
    carroIcon: {
        color: theme.palette.primary[300],
        position: "relative",
        top: theme.spacing(1),
        marginLeft: 10
    },
    divSwipe: {
        [theme.breakpoints.down('xs')]: {
            paddingBottom: 15
        }
    },
    divider: {
        margin: '10px 0'
    },
    nome: {
        marginLeft: 10
    }
}));

function ListagemServicoPage(
    {
        match
    }
) {
    const classes = styles();
    const mobile = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const { placa } = match.params;
    const lista = [
        {
            servico: 'Revisão 10.000 Km',
            nomeConcessionaria: 'Concessionária Roma',
            enderecoConcessionaria: 'Av. Cristiano Machado, 2875',
            telefone: '(31) 2344-3456',
            contato: 'Fernando',
            data: '24/08',
            hora: '10:00',
            numero: '254WGA/10'
        },
        {
            servico: 'Troca de óleo',
            nomeConcessionaria: 'Concessionária Automax',
            enderecoConcessionaria: 'Av. Raja Gabaglia, 2222',
            telefone: '(31) 5555-7777',
            contato: 'Fernando',
            data: '29/08',
            hora: '14:00',
            numero: '254WGA/10'
        },
        {
            servico: 'Troca de pneu',
            nomeConcessionaria: 'Concessionária Roma',
            enderecoConcessionaria: 'Av. Cristiano Machado, 2875',
            telefone: '(31) 2323-9999',
            contato: 'Fernando',
            data: '30/08',
            hora: '16:00',
            numero: '254WGA/10'
        },
        {
            servico: 'Troca de pneu',
            nomeConcessionaria: 'Concessionária Roma',
            enderecoConcessionaria: 'Av. Cristiano Machado, 2875',
            telefone: '(31) 2323-9999',
            contato: 'Fernando',
            data: '30/08',
            hora: '16:00',
            numero: '254WGA/10'
        }, {
            servico: 'Troca de pneu',
            nomeConcessionaria: 'Concessionária Roma',
            enderecoConcessionaria: 'Av. Cristiano Machado, 2875',
            telefone: '(31) 2323-9999',
            contato: 'Fernando',
            data: '30/08',
            hora: '16:00',
            numero: '254WGA/10'
        }
    ];

    return (
        <>
            <Header titulo='Serviços'
                link={MenuEnum.properties[MenuEnum.HOME].path} />
            <Body>
                <Typography variant='caption'>
                    <CarroIcon className={classes.carroIcon} />
                    {placa}
                </Typography>
                <Typography variant='caption' className={classes.nome}>
                    Bruno Silva
                </Typography>
                <Divider className={classes.divider} />
                {
                    (() => {

                        if (1 === 2)
                            return <>
                                <Grid container>
                                    <Grid item
                                        sm={4}>
                                        <CardServicoInexistente />
                                    </Grid>
                                </Grid>
                            </>

                        return <>
                            <Grid container>
                                <Grid item
                                    xs={12}
                                    sm={6}>
                                    <Typography variant='subtitle1'
                                        className={classes.titulo}>
                                        Agendado(s)
                                    </Typography>
                                    {
                                        (() => {
                                            if (mobile) {
                                                let listaAgendados = lista.map((item, index) => (
                                                    <div key={index}
                                                        className={classes.divSwipe}>
                                                        <CardServico servico={item}
                                                            color='secondary' />
                                                    </div>
                                                ));

                                                return <SwiperCard lista={listaAgendados} />
                                            }

                                            let listaAgendados = lista.map((item, index) => (
                                                <CardServico key={index}
                                                    servico={item}
                                                    color='secondary' />
                                            ));

                                            return <StepperCard lista={listaAgendados} />
                                        })()
                                    }
                                </Grid>
                                <Grid item
                                    xs={12}
                                    sm={6}>
                                    <Typography variant='subtitle1'
                                        className={classes.titulo}>
                                        Histórico
                                    </Typography>
                                    {
                                        (() => {
                                            if (mobile) {
                                                let listaHistorico = lista.map((item, index) => (
                                                    <div key={index}
                                                        className={classes.divSwipe}>
                                                        <CardServico servico={item}
                                                            color='disabled'
                                                            disabled />
                                                    </div>
                                                ));

                                                return <SwiperCard lista={listaHistorico} />
                                            }
                                            let listaHistorico = lista.map((item, index) => (
                                                <CardServico key={index}
                                                    servico={item}
                                                    color='disabled'
                                                    disabled />
                                            ));

                                            return <StepperCard lista={listaHistorico} />
                                        })()
                                    }
                                </Grid>
                            </Grid>
                        </>
                    })()
                }
            </Body>
        </>
    );
}

export default withRouter(ListagemServicoPage);